// Placeholder range holding each base's own default swatch rather than a real color family.
export const NO_RANGE_INDICATOR = '#N/D';

export const paintColorsPalette = [
	{ color: '#FFFFFF', name: NO_RANGE_INDICATOR },
	{ color: '#FFFFFF', name: 'Pasteles' },
	{ color: '#5C5C5C', name: 'Grises' },
	{ color: '#744E3C', name: 'Cafés' },
	{ color: '#D01D1F', name: 'Rojos' },
	{ color: '#E7873C', name: 'Naranjas' },
	{ color: '#F8D65C', name: 'Amarillos' },
	{ color: '#6CA74D', name: 'Verdes' },
	{ color: '#19E3E3', name: 'Aquas' },
	{ color: '#417AD6', name: 'Azules' },
	{ color: '#846BC6', name: 'Morados' },
];
